import _ from 'lodash'
import { tmrDialogController } from 'tmr/controllers/dialog/dialog'
import templateUrl from './phaseToPhaseDialog.html'
import './phaseToPhaseDialog.scss'

/**
 * Configures dialog Items by Upc (preset `tmrPhaseToPhase`).
 *
 * @type {ngConfig}
 */
function tmrPhaseToPhaseDialogConfig($mdDialogProvider) {
  'ngInject'
  $mdDialogProvider.addPreset('tmrPhaseToPhase', {
    options: /*@ngInject*/ () => ({
      templateUrl,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: 'tmrPhaseToPhaseDialogController',
      controllerAs: '$ctrl',
      bindToController: true,
      locals: {
        lots: [],
      },
    }),
  })
}

export { tmrPhaseToPhaseDialogConfig as config }

/**
 * Controller of Dialog {@link tmrPhaseToPhaseDialogConfig tmrPhaseToPhase}.
 *
 * @type {ngController}
 */
export class tmrPhaseToPhaseDialogController extends tmrDialogController {
  constructor($mdDialog, $transitions, Place, ProductionLot, TmrToast) {
    'ngInject'
    super($mdDialog, $transitions)
    Object.assign(this, { Place, ProductionLot, TmrToast })
  }

  $onInit() {
    super.$onInit()
    this.externalWorkerProduction = false
    this.orderedPhases = []
    this.btnActions = []
    this.operationSelected = null
    this.place = null
    this.nextPhaseStatus = null // store value about next phase to follow the workflow

    this.setWorkflowPhases()
  }

  // get workflow from lot and set phases btn
  setWorkflowPhases() {
    const workflow = this.lots[0].workflow
    if (workflow.phases) {
      this.orderedPhases = workflow.phases.sort((a, b) => {
        return a.phaseOrder > b.phaseOrder
          ? 1
          : b.phaseOrder > a.phaseOrder
          ? -1
          : 0
      })

      // check if all this.lots are in the same status phase
      let currentPhase = this.getLotsCurrentPhase()
      // suggest next status phase
      if (currentPhase !== 'ERROR' && currentPhase !== 'MIXED') {
        this.setNextPhaseStatus(currentPhase)
      }

      // get buttons design
      this.btnActions = this.getProductionLotActions()
    }
  }

  /** get suggest for next phase */
  setNextPhaseStatus(currentPhase) {
    // lot status INIT case
    if (currentPhase === 'INIT') {
      if (this.orderedPhases[0]) {
        this.nextPhaseStatus = {
          phase: this.orderedPhases[0],
          operation: 'start',
        }
        this.onPhaseSelected(this.orderedPhases[0], 'start')
      }
      return
    }

    // set next phase
    const idx = this.orderedPhases.findIndex(
      phase => phase.id === currentPhase.phase.id
    )
    const phaseStatus = this.getOperationPhase(currentPhase)
    if (phaseStatus === 'IN_PROGRESS') {
      this.nextPhaseStatus = {
        phase: this.orderedPhases[idx],
        operation: 'end',
      }
      this.onPhaseSelected(this.orderedPhases[idx], 'end')
    } else if (this.orderedPhases[idx + 1] && this.orderedPhases[idx + 1].id) {
      this.nextPhaseStatus = {
        phase: this.orderedPhases[idx + 1],
        operation: 'start',
      }
      this.onPhaseSelected(this.orderedPhases[idx + 1], 'start')
    }
  }

  // check if this.lots are in the same status phase
  getLotsCurrentPhase() {
    let currentPhase = null

    // get Ids about orderedPhases -> phase.id
    const orderedPhaseIds = this.orderedPhases.map(({ id }) => id)

    // check if are all in the same phase
    for (let i = 0; i < this.lots.length; i++) {
      // check if tag currentPhase is in userWorkflow phases list
      const current = this.lots[i].currentPhase
      if (current && !orderedPhaseIds.includes(current.phase.id)) {
        currentPhase = 'ERROR'
        break
      }

      // set first value for currentPhase
      if (!currentPhase) currentPhase = this.lots[i].currentPhase || 'INIT'

      if (this.lots[i].currentPhase) {
        // check if this.lots[i] currentPhase is the same of others this.lots[i] currentPhase
        // and are in the same operation phase
        if (
          currentPhase === 'INIT' ||
          currentPhase.phase.id !== this.lots[i].currentPhase.phase.id ||
          this.getOperationPhase(currentPhase) !==
            this.getOperationPhase(this.lots[i].currentPhase)
        ) {
          currentPhase = 'MIXED'
          break
        }
      } else {
        // check if tag read hasn't currentPhase, but already exists currentPhase for old tags read
        if (currentPhase && currentPhase !== 'INIT') {
          currentPhase = 'MIXED'
          break
        }
      }
    }

    // Check if currentPhase is null -> set to initial phase
    if (!currentPhase) currentPhase = 'INIT'

    return currentPhase
  }

  /** from phase get it's operation status */
  getOperationPhase(phase) {
    if (!phase || (!phase.startDate && !phase.completionDate)) return null
    if (phase.startDate && !phase.completionDate) return 'IN_PROGRESS'
    if (phase.startDate && phase.completionDate) return 'COMPLETED'
    return null
  }

  /** get places list for select menu */
  getPlaces(value) {
    return this.Place.search({ value }).$promise
  }

  /** reset selected value */
  onChangeExternalWorkerValue() {
    this.place = null
    this.operationSelected = null
  }

  /** Get Phase Actions */
  getProductionLotActions() {
    return this.orderedPhases.map(phase =>
      _.merge(phase, {
        operationType: this.externalWorkerProduction ? 'external' : 'internal',
      })
    )
  }

  /** callback action on selected place change value */
  selectedPlaceChange(place) {
    if (!place) this.operationSelected = null
  }

  /** set selected phase and operation  */
  onPhaseSelected(phase, operation) {
    this.operationSelected = { phase, operation }
  }

  /** update lots to selected phase operation*/
  onClickProceed() {
    if (this.lots && this.operationSelected) {
      this.ProductionLot.updateProgress({
        productionLots: this.lots,
        targetWorkflowPhase: this.operationSelected.phase,
        startDate:
          this.operationSelected.operation === 'start'
            ? new Date().getTime()
            : null,
        endDate:
          this.operationSelected.operation === 'end'
            ? new Date().getTime()
            : null,
        externalWorker: this.place || null,
      }).$promise.then(
        () => this.$mdDialog.hide('updateProgressDone'),
        err => this.TmrToast.exception(err)
      )
    }
  }

  // abort phase to phase process
  onClickAbort() {
    this.$mdDialog.hide()
  }
}
